import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

/**
 * What a tracker add (`bulkAddToTracker`, `bulkAddCompanyToTracker`) refreshes: the destination
 * list and the leads, and only when the add went through (PREC-4497).
 *
 * The list table's row selection lives only as long as its rows are not refetched. A failed add
 * keeps the dialog open for a retry, and a refetch after the failure cleared the selection under
 * it, so the retry had nothing left to send. A failed add changed nothing, so nothing is refreshed.
 */
export const trackerAddInvalidatedTags = (
	error: FetchBaseQueryError | unknown,
	arg: { listId?: number }
): Array<"ListPerson" | { type: "List"; id: number }> => {
	if (error) {
		return [];
	}

	return arg.listId ? [{ type: "List", id: arg.listId }, "ListPerson"] : ["ListPerson"];
};
